<app-stage
  title="Ihre persönliche Beratung"
  subtitle="Sie haben möchten einen Tarif abschließen oder haben Fragen? Hinterlassen Sie einfach Ihren Kontaktwunsch (per Rückruf oder als schriftlicher Kontakt) – Unsere Experten beraten Sie, wenn es für Sie am besten passt."
  imageSrc="assets/images/contact_image.webp"
  imageAlt="Mann und Frau stehen zwischen Umzugskartons und lächeln in die Kamera. Der Mann hält eine blaue Box unter dem Arm, wo eine Sprechblase hervorkommt mit dem Titel „SYMBOX – So schnell war ich noch nie zu Hause“" />

<div class="contact-container">
  <div class="contact-form-section">
    <h2 class="h2">Beratung vereinbaren</h2>

    <p class="required-hint">*Pflichtangabe</p>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" aria-label="Kontaktformular">
      <app-form-radio [controlConfig]="salutationConfig" [formGroup]="contactForm" [hasError]="false" />

      <div class="form-row">
        <app-form-input [controlConfig]="firstNameConfig" [formGroup]="contactForm" [hasError]="false" />

        <app-form-input [controlConfig]="lastNameConfig" [formGroup]="contactForm" [hasError]="false" />
      </div>

      <div class="contact-method">
        <app-form-radio [controlConfig]="contactMethodConfig" [formGroup]="contactForm" [hasError]="false" />
      </div>

      <!-- Telefonisch specific fields -->
      <ng-container *ngIf="contactForm.get('contactMethod')?.value === 'phone'">
        <app-form-input [controlConfig]="phoneNumberConfig" [formGroup]="contactForm" [hasError]="false" />

        <div class="form-row">
          <p class="form-hint">Wählen Sie den Zeitpunkt Ihres Rückrufs. Unsere Rückrufzeiten: Mo-Sa: 08:00 - 19:00 Uhr</p>

          <app-form-select [controlConfig]="weekdayConfig" [formGroup]="contactForm" [hasError]="false" />

          <app-form-select [controlConfig]="timeRangeConfig" [formGroup]="contactForm" [hasError]="false" />
        </div>
      </ng-container>

      <!-- Schriftlich specific fields -->
      <ng-container *ngIf="contactForm.get('contactMethod')?.value === 'written'">
        <app-form-input [controlConfig]="emailConfig" [formGroup]="contactForm" [hasError]="false" />
      </ng-container>

      <app-form-checkbox [controlConfig]="privacyConfig" [formGroup]="contactForm" [hasError]="false" />

      <app-button
        type="primary"
        text="Absenden"
        [disabled]="!contactForm.valid"
        [attr.aria-disabled]="!contactForm.valid"
        (clicked)="onSubmit()">
      </app-button>
    </form>
  </div>

  <div class="contact-info-section">
    <h3 class="h3">Sofort mit Experten sprechen</h3>
    <a href="tel:0800-103-0010" class="phone-number" aria-label="Sofort mit Experten sprechen unter 0800-103-0010"> 0800-103-0010 </a>
    <p class="availability">
      Natürlich können Sie auch direkt unseren Berater kontaktieren. Wir sind von Mo. - Sa. 8:00 - 19:00 Uhr für Sie erreichbar.
    </p>
  </div>
</div>
